import React from 'react';
import { Link } from 'react-router-dom';
import BookingHeader from './BookingHeader';
import { config } from '../config';
import "../../../assets/styles/booking.css";

const BookingDetails = () => {
    const bookingData = (() => {
        try {
            const raw = localStorage.getItem('last_booking');
            return raw ? JSON.parse(raw) : null;
        } catch { return null; }
    })();

    if (!bookingData) {
        return (
            <div className="booking-page-wrap">
                <BookingHeader title="Booking Details" showBack backTo={`${config.appUrl}`} backLabel="Back to Home" />
                <div className="booking-details-empty">
                    <i className="bi bi-calendar-x"></i>
                    <h3>No Booking Found</h3>
                    <p>You don't have any active booking to view.</p>
                    <Link to={`${config.appUrl}book-a-lesson`} className="booking-btn-next">
                        Book a Lesson
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className="booking-page-wrap">
            <BookingHeader title="Booking Details" showBack backTo={`${config.appUrl}`} backLabel="Back to Home" />

            <div className="booking-details-container">
                <div className="booking-details-title-row">
                    <h1>Booking Details</h1>
                </div>

                <div className="booking-details-grid">
                    {/* LEFT SIDE */}
                    <div className="booking-details-left">
                        {/* Lesson Info Card */}
                        <div className="booking-details-card">
                            <div className="booking-details-lesson-header">
                                {bookingData.image && (
                                    <img
                                        src={`${config.imageUrl}${bookingData.image}`}
                                        alt={bookingData.courseName}
                                        className="booking-details-lesson-img"
                                    />
                                )}
                                <div className="booking-details-lesson-info">
                                    <h3>{bookingData.courseName || 'Driving Lesson'}</h3>
                                    <p className="booking-details-instructor-name">
                                        <i className="bi bi-person-fill me-2"></i>
                                        {bookingData.instructorName || 'N/A'}
                                    </p>
                                    <span className={`booking-details-status ${bookingData.status === 'confirmed' ? 'confirmed' : 'pending'}`}>
                                        <i className="bi bi-check-circle-fill me-1"></i>
                                        {bookingData.status === 'confirmed' ? 'Confirmed' : 'Pending'}
                                    </span>
                                </div>
                            </div>

                            <div className="booking-details-info-rows">
                                <div className="booking-details-info-row">
                                    <span className="booking-details-info-label">
                                        <i className="bi bi-calendar3"></i> Date
                                    </span>
                                    <span className="booking-details-info-value">{bookingData.date || 'N/A'}</span>
                                </div>
                                <div className="booking-details-info-row">
                                    <span className="booking-details-info-label">
                                        <i className="bi bi-clock"></i> Time
                                    </span>
                                    <span className="booking-details-info-value">{bookingData.time || 'N/A'}</span>
                                </div>
                                <div className="booking-details-info-row">
                                    <span className="booking-details-info-label">
                                        <i className="bi bi-credit-card"></i> Total Paid
                                    </span>
                                    <span className="booking-details-info-value booking-details-price">
                                        {bookingData.amount || 'N/A'}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Pickup Location Card */}
                        <div className="booking-details-card">
                            <h4 className="booking-details-card-heading">
                                <i className="bi bi-geo-alt-fill text-green me-2"></i>
                                Pickup Location
                            </h4>
                            <p className="booking-details-address">
                                {bookingData.address || 'No pickup address provided'}
                            </p>
                            {bookingData.postalCode && (
                                <div className="booking-details-postcode-box">
                                    <i className="bi bi-mailbox2 me-2"></i>
                                    Postal Code: {bookingData.postalCode}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* RIGHT SIDE */}
                    <div className="booking-details-right">
                        {/* Contact Instructor Card */}
                        <div className="booking-details-card">
                            <h4 className="booking-details-card-heading">
                                <i className="bi bi-chat-dots-fill text-green me-2"></i>
                                Contact Instructor
                            </h4>
                            <p className="booking-details-card-text">
                                You can reach out to your instructor directly for any questions about your lesson.
                            </p>
                            <a href={`mailto:${bookingData.instructorEmail || ''}`} className="booking-details-btn-green">
                                <i className="bi bi-envelope-fill me-2"></i>
                                Message {bookingData.instructorName || 'Instructor'}
                            </a>
                        </div>

                        {/* Manage Booking Card */}
                        <div className="booking-details-card">
                            <h4 className="booking-details-card-heading">
                                <i className="bi bi-gear-fill text-green me-2"></i>
                                Manage Booking
                            </h4>
                            <p className="booking-details-card-text">
                                You can reschedule or cancel up to 24 hours before your lesson without a penalty.
                            </p>
                            <div className="booking-details-manage-btns">
                                <Link
                                    to={`${config.appUrl}reschedule`}
                                    state={{ bookingData }}
                                    className="booking-details-btn-green"
                                >
                                    <i className="bi bi-arrow-repeat me-2"></i>
                                    Reschedule Lesson
                                </Link>
                                <button type="button" className="booking-details-btn-dark" onClick={() => {
                                    if (window.confirm('Are you sure you want to cancel this lesson?')) {
                                        localStorage.removeItem('last_booking');
                                        window.location.href = config.appUrl;
                                    }
                                }}>
                                    <i className="bi bi-x-circle me-2"></i>
                                    Cancel Lesson
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingDetails;
